export default __webpack_public_path__ + "static/media/mouse-click-wheel-drag.57405540.svg";